import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.6904 40.5984C73.6904 40.5984 60.1304 33.7084 56.0804 28.9784C51.5804 23.7184 51.7804 1.07837 51.7804 1.07837H39.3504C39.3504 1.07837 39.6604 23.8284 35.0504 28.9784C30.1604 34.4384 17.4404 40.3983 17.4404 40.3983C23.6304 54.9783 36.0304 58.6984 45.5604 58.6984C55.0904 58.6984 67.4904 55.1784 73.6904 40.5984Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M87.22 57.4884C85.66 45.4784 82.01 42.2383 77.34 39.8883C74.83 38.6183 63.92 34.2283 60.25 31.0483C57.91 29.0283 54.9 25.0283 54.9 25.0283C54.9 25.0283 51.98 31.3384 45.57 31.3384C39.16 31.3384 36.24 25.0283 36.24 25.0283C36.24 25.0283 33.39 29.3183 30.33 31.4183C26.12 34.3083 16.31 38.6183 13.8 39.8883C9.13 42.2383 5.57 45.8684 3.92 57.4884C2.44 68.5484 2 71.3083 2 71.3083H89.15C89.14 71.3083 88.52 67.7884 87.22 57.4884Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M25.6904 33.1583C25.6904 33.1583 31.0604 43.2284 45.9204 43.2284C60.1204 43.2284 65.3504 33.1583 65.3504 33.1583"
        stroke={outline}
        strokeMiterlimit="10"
        fill="none"
      />
      <path d="M45.5596 31.3484V43.0183" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M41.9001 30.6884L37.8301 41.9083" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M38.4896 28.5884L30.8896 38.1683" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M49.1904 30.6884L53.2704 41.9083" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <path d="M52.6104 28.5884L60.2004 38.1683" stroke={outline} strokeWidth="0.5" strokeMiterlimit="10" />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="45.5619"
          y1="29.7245"
          x2="45.5619"
          y2="20.0066"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
